<template>
  <div
    :class="addClass + ' filter-option select-item-font d-inline-flex align-items-center justify-content-center' + (active ? ' active' : '') + (icon ? ' with-icon' : '')"
    :style="icon ? iconStyle : ''"
    @click="$emit('click')"
  >
    {{ title }}
  </div>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: null
    },
    addClass: {
      type: String,
      default: ''
    }
  },
  data () {
    return {

    }
  },
  computed: {
    iconStyle () {
      return `background-image: url(${this.icon})`
    }
  },
  created () {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
  .filter-option {
    border: 2px solid $nh-gray;
    border-radius: 5px;
    padding: 0.40rem 0.85rem;
    background-repeat: no-repeat;
    background-position: left 0.6rem center;
    background-size: auto 18px;
    cursor: pointer;
    text-align: center;
  }
  .with-icon {
    padding-left: 1.9rem;
  }
  .active {
    border-color: $warning;
  }
</style>
